export default __webpack_public_path__ + "static/media/LEGEND.3f62b735.bin";